import { Button, Typography, Card } from "antd";
import { FileUnknownOutlined, DownloadOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { getFileUrl } from "../config";

const { Title, Paragraph } = Typography;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 200px);
  background-color: #fafafa;
`;

const StyledCard = styled(Card)`
  text-align: center;
  border: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  max-width: 480px;

  .ant-typography {
    color: #7c4095;
  }

  .ant-btn-primary {
    background-color: #7c4095;
    border-color: #7c4095;
  }

  .ant-btn-primary:hover,
  .ant-btn-primary:focus {
    background-color: #693682;
    border-color: #693682;
  }
`;

const UnsupportedPreview = ({ fileKey }: { fileKey: string }) => {
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fafafa",
        border: "1px dashed #d9d9d9",
        borderRadius: 8,
      }}
    >
      <div style={{ textAlign: "center", maxWidth: 400, margin: "42px" }}>
        <Typography.Title level={4} style={{ marginTop: 0 }}>
          <FileUnknownOutlined style={{ color: "#7C4095" }} /> Preview Not
          Available
        </Typography.Title>
        <Typography.Text>
          This file type cannot be previewed in the browser. However, you can
          still securely upload and download anytime.
        </Typography.Text>
        <div style={{ marginTop: 24 }}>
          <DownloadFileButton fileKey={fileKey} />
        </div>
      </div>
    </div>
  );
};

export default UnsupportedPreview;

export const DownloadFileButton = ({ fileKey }: { fileKey: string }) => {
  const handleDownload = () => {
    const url = getFileUrl(fileKey);
    const link = document.createElement("a");
    link.href = url;
    link.download = ""; // browser uses filename from response headers
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Button
      type="primary"
      icon={<DownloadOutlined />}
      disabled={!fileKey}
      onClick={handleDownload}
    >
      Download File
    </Button>
  );
};
